// src/components/ConfirmStripeDisconnectModal.js
import React from 'react';

const ConfirmStripeDisconnectModal = ({ isOpen, onConfirm, onCancel, isDisconnecting }) => {
    if (!isOpen) return null;

    const message = `
        ¿Estás seguro de que quieres eliminar la vinculación con Stripe?
        <br/><br/>
        • <strong>Importante:</strong> Cualquier saldo pendiente en esta cuenta de Stripe se seguirá transfiriendo a tu banco según lo programado.
        <br/>
        • Ya no podrás recibir nuevas donaciones a través de Stripe en Typefiction con esta vinculación.
        <br/>
        • Perderás el acceso rápido al panel de control de esta cuenta específica desde Typefiction.
        <br/><br/>
        Esta acción solo elimina la conexión con nuestra plataforma; tu cuenta de Stripe seguirá existiendo. Puedes volver a vincularla (o una nueva) más tarde si lo deseas.
    `;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-[120]">
            <div className="bg-gray-800 rounded-lg shadow-xl w-full max-w-lg p-6 text-white relative">
                <h2 className="text-2xl font-bold mb-4">Confirmar Eliminación de Vinculación</h2>
                {/* Usamos dangerouslySetInnerHTML para permitir los <br/> y <strong> */}
                <p 
                    className="text-gray-300 mb-6 leading-relaxed" 
                    dangerouslySetInnerHTML={{ __html: message }}
                />
                <div className="flex justify-end space-x-4">
                    <button 
                        onClick={onCancel} 
                        disabled={isDisconnecting}
                        className="px-6 py-2 font-bold text-gray-300 bg-gray-600 rounded-md hover:bg-gray-500 disabled:opacity-50"
                    >
                        Cancelar
                    </button>
                    <button 
                        onClick={onConfirm} 
                        disabled={isDisconnecting}
                        className="px-6 py-2 font-bold text-white bg-red-600 rounded-md hover:bg-red-700 disabled:opacity-50"
                    >
                        {isDisconnecting ? 'Eliminando...' : 'Sí, eliminar vinculación'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmStripeDisconnectModal;